export default __webpack_public_path__ + "static/media/125.fd3a0aab.webp";